import * as React from 'react';

import * as style from './ModalBody.styl';

interface IModalBodyProps {
  scrollable?: boolean;
  children?: React.ReactNode;
}

export class ModalBody extends React.Component<IModalBodyProps> {
  render() {
    return <div className={style.global + (this.props.scrollable ? ' overflow-scroll' : '')}>{this.props.children}</div>;
  }
}
